import { BaseSubLineItemResource } from "shared/actions/roomBookActions";
import { UPDATE_PAGE_CONTENT } from "shared/constants/appConstants";

import localStorage from "shared/helpers/localStorage";

import es6Promise from "es6-promise";
import { buyerSelectionToResourceValues } from "../../buyer_portal/actions/roomBookActions";

es6Promise.polyfill();
// es lint:
/* global Promise */

export class ProductLineResource {
  constructor(dispatch, unitId) {
    this.dispatch = dispatch;
    this.unitId = unitId;
  }

  select(value) {
    return new Promise(resolve => {
      const selections =
        JSON.parse(localStorage.get("productLineSelection")) || {};
      selections[this.unitId] = value;

      localStorage.set("productLineSelection", JSON.stringify(selections));

      this.dispatch({
        type: UPDATE_PAGE_CONTENT,
        payload: { product_line_selection: { tag: value } }
      });
      resolve({ status: 200 }); // fakes a successful apiRequest response
    });
  }
}

export class SubLineItemResource extends BaseSubLineItemResource {
  constructor(dispatch) {
    super(dispatch);
  }

  selectProducts(buyerSelections) {
    return this.selectProductsAndQuantities(
      buyerSelectionToResourceValues(buyerSelections)
    );
  }

  selectProduct(lineItemId, product) {
    return this.selectProducts({
      [lineItemId]: product.id
    });
  }

  deselectProducts(lineItemIds) {
    return this.selectProducts(
      lineItemIds.reduce((a, id) => {
        return { ...a, [id]: "_destroy" };
      }, {})
    );
  }

  deselectProduct(lineItemId) {
    return this.deselectProducts([lineItemId]);
  }

  selectProductsAndQuantities(buyer_selections) {
    return new Promise(resolve => {
      const buyerSelections =
        JSON.parse(localStorage.get("buyerSelections")) || {};
      Object.entries(buyer_selections).forEach(([lineItemId, value]) => {
        if (value === "_destroy") {
          delete buyerSelections[lineItemId];
        } else {
          buyerSelections[lineItemId] = value;
        }
      });
      localStorage.set("buyerSelections", JSON.stringify(buyerSelections));

      this.dispatch({
        type: UPDATE_PAGE_CONTENT,
        payload: { buyer_selections: buyerSelections }
      });
      resolve({ status: 200 }); // fakes a successful apiRequest response
    });
  }
}
